import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

import { Button } from '../button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../dialog'

interface PaymentJustificationModalProps {
  referenceDate: string
  isLoading?: boolean
  descriptionStatus: string
  isShowButtonSave?: boolean
  openModal: boolean
  openChangeModal: (open: boolean) => void
  children: ReactNode
}

export function PaymentJustificationModal({
  children,
  openModal,
  referenceDate,
  openChangeModal,
  descriptionStatus,
  isLoading = false,
  isShowButtonSave = false,
}: PaymentJustificationModalProps) {
  return (
    <Dialog open={openModal} onOpenChange={openChangeModal}>
      <DialogContent className="h-auto max-w-216">
        <DialogHeader className="gap-1 text-start">
          <DialogTitle className="text-bios-secondary">
            Justificativa do pagamento
          </DialogTitle>
          <DialogDescription>
            Referente a {referenceDate} | Status: {descriptionStatus}
          </DialogDescription>
        </DialogHeader>
        {/* // INFO: O conteúdo do formulário deve ser passado como children para o
        componente, para que seja possível reutilizar o modal em outras telas,
        caso necessário. */}
        {children}

        <DialogFooter className="md:justify-end">
          <DialogClose asChild>
            <Button
              variant="outline"
              className={twMerge(
                'w-full',
                isShowButtonSave ? 'md:max-w-34' : 'md:max-w-52',
              )}
            >
              Cancelar
            </Button>
          </DialogClose>
          {isShowButtonSave && (
            <Button
              disabled={isLoading}
              isSubmitting={isLoading}
              form="payment-justification-form"
              className="w-full md:max-w-52"
            >
              Salvar justificativa
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
